import { type JSX } from 'react';
import { SvgIconProps } from '@mui/material';

type Props = {
  active?: boolean;
  activeColor?: string;
  visible?: boolean;
} & SvgIconProps;

export function ChevronDown(props: Props): JSX.Element | null {
  const {
    active = true,
    color = '#949494',
    activeColor = 'black',
    strokeWidth = '1.75',
    visible = true,
    ...rest
  } = props;

  if (!visible) return null;

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M3 7.75L11.9955 16.75L21 7.75'
        stroke={active ? activeColor : color}
        strokeWidth={strokeWidth}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
